module.exports = __webpack_public_path__ + "img/15_1.3eb705ea.jpg";